
import PropTypes from 'prop-types';
import FolderIcon from '@mui/icons-material/Folder';
import SvgIcon from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Chip from '@mui/material/Chip';
import { useTranslation } from "react-i18next";

export const SideNavItem = (props) => {
  const { active = false, disabled, title, empty } = props;

  const {  t } = useTranslation();

  return (
    <li>
      <ButtonBase
        sx={{
          alignItems: 'center',
          borderRadius: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          pl: '6px',
          pr: '16px',
          py: '6px',
          textAlign: 'left',
          width: '100%',
          ...(active && {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          }),
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.06)'
          }
        }}
      >
          <Box
            component="span"
            sx={{
              alignItems: 'center',
              color: 'neutral.400',
              display: 'inline-flex',
              justifyContent: 'center',
              mr: 2,
              ...(active && {
                color: 'primary.main'
              })
            }}
          >
          <SvgIcon fontSize="small">
            <FolderIcon />
          </SvgIcon>
          </Box>
        <Box
          component="span"
          sx={{
            color: 'neutral.400',
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 16,
            fontWeight: 700,
            lineHeight: '24px',
            whiteSpace: 'nowrap',          
            ...(active && {
              color: 'common.white'
            }),
            ...(disabled && {
              color: 'neutral.500'
            })
          }}
        >
          {title} 
        </Box>
        <Box sx={{pl:1}}>{empty===0 && <Chip label={t("Empty")} variant="outlined" 
        sx={{color: 'neutral.400',
          ...(active && {
              color: 'common.white'
            }),
            ...(disabled && {
              color: 'neutral.400'
            }) }}/>}</Box>
      </ButtonBase>
    </li>
  );
};

SideNavItem.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  icon: PropTypes.node,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  empty: PropTypes.number,
};
